import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import Setup from 'modules/Setup';
import { usePatientProfileForm } from './hooks';
const Actions = ({ validatorRules })=>{
    const { formName, formValues } = usePatientProfileForm();
    const authorizationCode = useSelector(CloudDrive.selectors.authorizationCode);
    const isInProgress = useSelector(Setup.selectors.isCreatePatientProfileInProgress);
    const validateWithErrorsDisplay = App.hooks.useFormProcessing(formName);
    const onCheck = ()=>{
        validateWithErrorsDisplay(formValues, validatorRules);
    };
    const isDisabled = App.hooks.useIsFormNotCompleted(formValues, validatorRules);
    return /*#__PURE__*/ _jsx("div", {
        className: "row",
        children: /*#__PURE__*/ _jsx("div", {
            className: "col-12",
            children: /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                labelMessage: Account.messages.buttons.continue,
                className: "btn--block btn--filled",
                isDisabled: isDisabled || !authorizationCode,
                isInProgress: isInProgress,
                onClickDisabled: onCheck
            })
        })
    });
};
export default Actions;
